var scarcitynumber_countdownInterval;

function countdown(minutes, seconds, callback) {
  var seconds = seconds;
  var mins = minutes

  scarcitynumber_countdownInterval = setInterval(function() {
    if (seconds < 1) {
      seconds = 60;
      mins--;
    }
    seconds--;

    callback(mins, seconds);

    if (mins == 0 && seconds == 0) 
      clearInterval(scarcitynumber_countdownInterval);

  }, 1000);
}    

window.addEventListener('DOMContentLoaded', (event) => {

		// Scarcity Number
        if (show_leftinstock)
        {
		  var scarcityElement = '#scarcitynumber';       
          var numberLeft = -1;
          if (localStorage.getItem('ItemsLeft_' + productID) > 0) {
              numberLeft = localStorage.getItem('ItemsLeft_' + productID);	
          } else {
              numberLeft =  Math.floor(randomInt(9, 15));
              localStorage.setItem('ItemsLeft_' + productID, numberLeft);
          }
            document.querySelector(scarcityElement).innerHTML = "Only <font color='red'>" + numberLeft + "</font>  left in stock."; 
            var interval = setInterval(function() {
              if (numberLeft <= 5) {
                clearInterval(interval);
                return;
              }

              if (randomInt(0, 100) <= 50) {  
                numberLeft--;
                localStorage.setItem('ItemsLeft_' + productID, numberLeft);  
                document.querySelector(scarcityElement).innerHTML = "Only <font color='red'>" + numberLeft + "</font> left in stock.";
              }

            }, (1000 * 24));
        }
  
  		
        // Countdown
        if (show_countdown)
        {


         
          
          var currentMinute = -1;
          var currentSecond = -1;
          var currentHour = 1;
          var countdownMinutes = localStorage.getItem('CountdownMinutes_' + productID); 
          if (countdownMinutes && !isNaN(countdownMinutes) && countdownMinutes > 0) {
            currentMinute = localStorage.getItem('CountdownMinutes_' + productID);
            currentSecond = localStorage.getItem('CountdownSeconds_' + productID);
          } else {
            currentMinute = randomInt(30, 59);
            currentSecond = randomInt(0, 59);      
            localStorage.setItem('CountdownMinutes_' + productID, currentMinute);
            localStorage.setItem('CountdownSeconds_' + productID, currentSecond);
          }
          document.querySelector('#countdownhour').innerText = '00';
          document.querySelector('#countdownminute').innerText = currentMinute;
          document.querySelector('#countdownsecond').innerText = currentSecond;    


          countdown(currentMinute, currentSecond, function(minutes, seconds) {

            var displayMinutes = minutes < 10 ? '0' + minutes : minutes;
            var displaySeconds = seconds < 10 ? '0' + seconds : seconds;
            var displayHours =  '0' + currentHour; 
            document.querySelector('#countdownhour').innerText  = displayHours;
            document.querySelector('#countdownminute').innerText = displayMinutes;
            document.querySelector('#countdownsecond').innerText = displaySeconds;
            localStorage.setItem('CountdownMinutes_' + productID, minutes);
            localStorage.setItem('CountdownSeconds_' + productID, seconds);      
          });



      }
 
 
  
});